import * as React from 'react';

import { ILocalization } from '@shared-ui/localization-context';

import { bexApiDateTimeToTimeLocKeyMap } from 'components/multi-item/bex-api-date-time-to-time-loc-key';

interface LocalizedTime {
  key: string;
  localizedTime: string;
}

interface StaticSelectOptionsProps {
  l10n: ILocalization;
}

const localizeTimes = (() => {
  const times: string[] = [];

  return (l10n: ILocalization) => {
    if (!times.length) {
      bexApiDateTimeToTimeLocKeyMap.map(([config, locKey]) => {
        times.push(locKey);
      });
    }

    return times;
  };
})();

export const StaticTimeSelectOptions: React.FunctionComponent<StaticSelectOptionsProps> = React.memo(({ l10n }) => (
  <>
    {localizeTimes(l10n).map(key => (
      <option value={key} key={key}>
        {l10n.formatText(`multiItem.searchWizard.timeSelect.${key}`)}
      </option>
    ))}
  </>
));
